import React, { FC } from "react";
import classNames from "classnames/dedupe";

import { IImageData, Image } from "../../Utility/MediaBuilder/Image";
import { ILink, Link } from "../../ActionsSelectors/Link";
import { ProductPrice, TPrice } from "../../DataDisplay/Price";

export interface IMiniProductCard {
  /** Identifier */
  id: string;
  /** Appearance */
  variant?: "default" | "image-only";
  /** Link entity for product */
  productLink?: ILink;
  /** Image entity for image */
  productImage: IImageData;
  /** Main title / name of product */
  productName?: string;
  /** Set of prices */
  prices: TPrice[];
  /** Additional classes/styles */
  classes?: {
    root?: string;
  };
}

const MiniProductCard: FC<IMiniProductCard> = ({
  id,
  variant = "default",
  productLink = null,
  productImage,
  productName = null,
  prices,
  classes,
}) => {
  const rootClasses = classNames(
    "d-inline-flex product-card__shopping-bag product-card__shopping-bag__mini product-card__shopping-bag__mini__comparison",
    classes?.root,
  );

  return (
    <figure className={rootClasses} key={id} data-testid="MiniProductCard">
      <Image {...productImage} />
      {variant === "image-only" ? null : (
        <figcaption className="justify-content-around">
          <div className="product-info">
            {/** TD: Move to `Link` or `LinkButton` component */}
            <Link classes={{ root: "product-title" }} {...(productLink || {})}>
              <div className="product-model">{productName}</div>
            </Link>
          </div>
          <div className="product-numbers">
            <ProductPrice
              classes={{
                root: "justify-content-start align-items-start flex-row",
              }}
              prices={prices}
            />
          </div>
        </figcaption>
      )}
    </figure>
  );
};

export default MiniProductCard;
